import {all} from 'redux-saga/effects'
import responseHandling from "./responseHandling/responseHandling.sagas.js";
import waiver from './waiver/waiver.sagas.js';
import onlineSales from './onlineSales/onlineSales.sagas.js';
import onlineSalesProcess from './onlineSalesProcess/onlineSalesProcess.sagas.js';

export default function* rootSaga()
{
  yield all([
    responseHandling(),
    waiver(),
    onlineSales(),
    onlineSalesProcess()
  ])
}